import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import i18next from 'i18next'
import { Dialog } from 'primereact/dialog'
import { Button } from 'primereact/button'
import moment from 'moment'

// local imports
import './NewPlanSideBar.scss'
import commonOffice from 'assets/images/koc_ortak_ofis.svg'
import myOffice from 'assets/images/kendi_sirketim.svg'
import homeOffice from 'assets/images/koc_uzaktan.svg'
import confirmCalendarImage from 'assets/images/remote-plan-confirm-image.png'
import { ISideBarModel } from 'types/CalendarType'
import { IRemoteOfficeType } from 'types/MainType'
import HomeOfficeTypeSelection from 'components/ui/HomeOfficeTypeSelection'

const NewPlanSideBar = (props: {
  model: ISideBarModel
  onClickOfficePlan: (arg0: any) => any
  onClickCommonPlan: (arg0: any) => any
  onClickRemotePlan: (arg0: any) => any
  types: any[]
  selectedType: IRemoteOfficeType | null
  setSelectedType: any
}) => {
  const { t } = useTranslation()
  const [displayDialog, setDisplayDialog] = useState(false)

  const homeOfficeText = t('tabs.remote-work')
  const commonOfficeText = t('most-used-words.common-working')
  const officeText = t('tabs.company-work')

  const formatDate = (date: Date) => {
    if (date === null || date === undefined) return ''
    let res = moment(date)
    return res.format('DD.MM.YYYY')
  }

  const onHide = () => {
    setDisplayDialog(false)
  }

  const renderFooter = (name: any) => {
    return (
      <div className="d-flex flex-row of-confirm-footer">
        <Button label={t('buttons.cancel')} onClick={onHide} className="p-button-outlined w-100" />
        <Button
          label={t('buttons.confirm')}
          onClick={() => {
            onClickRemotePlan(props?.model)
          }}
          className="w-100 of-button-primary"
          disabled={false}
        />
      </div>
    )
  }

  const onClickRemotePlan = (value: ISideBarModel) => {
    props?.onClickRemotePlan(value)
    onHide()
  }

  return (
    <>
      <div className="text-center">
        <p className="of-sidebar-header">{t('sidebar.new-notification')}</p>
        <p className="of-sidebar-description">{t('sidebar.create-notification')}</p>
      </div>
      <div className="of-plandate">
        <p className="of-plandate-text">
          <i className="pi pi-calendar of-pi-icon"></i>
          <span>Tarih:</span>
          {formatDate(props?.model?.day?.date)}
        </p>
      </div>
      <p className="mt-2 of-plandate-wheretowork">
        {t('sidebar.where-work')} {props?.model?.user?.name}?
      </p>
      <div className="d-flex ">
        <div
          className="m-1 of-plan-create-box of-bordered-box of-office-border flex-fill bg-officeplan of-clickable"
          onClick={() => props?.onClickOfficePlan(props?.model)}>
          <div className={'of-white-panel'}>
            <img className="of-new-plan-icon" src={myOffice} alt="" />
            <div className="d-flex of-plan-card-direction">
              <p>{officeText}</p>
              <i className="arrow pi pi-angle-right" onClick={() => props?.onClickOfficePlan(props?.model)} />
            </div>
          </div>
        </div>
        <div
          className="m-1 of-plan-create-box of-bordered-box of-common-border flex-fill bg-commonplan of-clickable"
          onClick={() => props?.onClickCommonPlan(props?.model)}>
          <div className={'of-white-panel'}>
            <img className="of-new-plan-icon" src={commonOffice} alt="" />

            <div className="d-flex of-plan-card-direction ">
              <p>{commonOfficeText}</p>
              <i className="arrow pi pi-angle-right" onClick={() => props?.onClickCommonPlan(props?.model)} />
            </div>
          </div>
        </div>
        <div
          className="m-1 of-plan-create-box of-bordered-box of-home-border flex-fill bg-homeplan of-clickable"
          onClick={() => setDisplayDialog(true)}>
          <div className={'of-white-panel'}>
            <img className="of-new-plan-icon" src={homeOffice} alt="" />
            <div className="d-flex of-plan-card-direction">
              <p>{homeOfficeText}</p>
              <i className="arrow pi pi-angle-right" onClick={() => setDisplayDialog(true)} />
            </div>
          </div>
        </div>
      </div>
      <Dialog
        header=""
        visible={displayDialog}
        position={'center'}
        modal
        style={{ width: '400px' }}
        footer={renderFooter('displayPosition')}
        onHide={onHide}
        draggable={false}
        resizable={false}
        dismissableMask={false}>
        <div className="d-flex flex-column of-newplan-confirm-dialog">
          <div className="of-confirm-image">
            <img src={confirmCalendarImage} alt="" />
          </div>
          <div>
            <p className="of-confirm-info">{t('dashboard.remote-office-notification')}</p>
          </div>
          {props.types.length > 0 && (
            <div className="mt-2 mb-4 ms-3" style={{ width: '320px' }}>
              <HomeOfficeTypeSelection
                selectedType={props.selectedType}
                setSelectedType={props.setSelectedType}
                types={props.types}
              />
            </div>
          )}

          <div className="of-confirm-detail">
            {props.types.length === 0 ? (
              <p>
                ‘{formatDate(props?.model?.day?.date)}’ {t('sidebar.in-date2')} {t('sidebar.remote-text2')}
              </p>
            ) : (
              <p>
                {t('sidebar.remote-text')} (
                {props.selectedType && i18next.language === 'tr'
                  ? props.selectedType.displayedText
                  : props.selectedType?.en}
                ) {t('sidebar.remote-text2')}
              </p>
            )}
          </div>
        </div>
      </Dialog>
    </>
  )
}

export default NewPlanSideBar
